<template>
  <el-card class="facility" shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facilities' }">Facilities</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$root.state.facility" :to="{ name: 'Facility' }">
          {{ String($root.state.facilityData.code).toUpperCase() }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="Info" name="info">
        <el-card v-loading="loading" shadow="never">
          <div class="info-section">
            <div class="info-controls">
              <el-switch v-if="isProd" style="margin-right: 1rem" v-model="sandboxFlag" active-color="#13ce66"
                inactive-color="#ff4949" active-text="Enable Sandbox" inactive-text="Disable Sandbox"
                @change="setSandboxFlag">
              </el-switch>
              <el-button v-if="hasAccess" @click="routeToEditFacility" type="primary" size="small">
                Edit
              </el-button>
              <el-button v-if="hasAccess" @click="() => bannerNoteDialogVisible = true" size="small">
                Edit Banner note
              </el-button>
            </div>

            <div class="info-details">
              <el-descriptions title="Facility" border direction="vertical">
                <el-descriptions-item label="Title" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.title }}
                </el-descriptions-item>
                <el-descriptions-item label="Code" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.code }}
                </el-descriptions-item>
                <el-descriptions-item label="County" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.county }}
                </el-descriptions-item>
                <el-descriptions-item label="Email" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.email }}
                </el-descriptions-item>
                <el-descriptions-item label="Accounting Email" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.accountingEmail }}
                </el-descriptions-item>
                <el-descriptions-item label="After Hours Email" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.afterhoursEmail }}
                </el-descriptions-item>
                <el-descriptions-item label="Legal Name" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.account }}
                </el-descriptions-item>
                <el-descriptions-item label="Total Sq. footage" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.size }}
                </el-descriptions-item>
                <el-descriptions-item v-if="data.facilityWithSize" label="Computed units size in Sq. footage"
                  :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ data.facilityWithSize }}
                </el-descriptions-item>
                <el-descriptions-item label="Time Zone" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.tz }}
                </el-descriptions-item>
              </el-descriptions>
              <el-divider></el-divider>
              <el-descriptions v-if="facilityData.addressInfo" title="Address" border direction="vertical">
                <el-descriptions-item label="Address Line 1" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.addressInfo.addressLine1 || '' }}
                </el-descriptions-item>
                <el-descriptions-item label="Address Line 2" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.addressInfo.addressLine2 || '' }}
                </el-descriptions-item>
                <el-descriptions-item label="Post Code" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.addressInfo.pinCode || '' }}
                </el-descriptions-item>
                <el-descriptions-item label="City" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.addressInfo.city || '' }}
                </el-descriptions-item>
                <el-descriptions-item label="State" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.addressInfo.state || '' }}
                </el-descriptions-item>
                <el-descriptions-item label="Country" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ country || '' }}
                </el-descriptions-item>
                <el-descriptions-item label="Currency" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ String(facilityData.pricing.currency).toUpperCase() || '' }}
                </el-descriptions-item>
                <el-descriptions-item v-if="facilityData.gst" label="GST Number" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.gst || '' }}
                </el-descriptions-item>
              </el-descriptions>
              <el-divider v-if="facilityData.addressInfo"></el-divider>
              <el-descriptions v-if="facilityData.manager" title="Manager" border direction="vertical">
                <el-descriptions-item label="Name" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.manager.name || '' }}
                </el-descriptions-item>
                <el-descriptions-item label="Email" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.manager.email || '' }}
                </el-descriptions-item>
                <el-descriptions-item label="Phone" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.manager.phone || '' }}
                </el-descriptions-item>
                <el-descriptions-item label="Region" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.region || '-' }}
                </el-descriptions-item>
              </el-descriptions>
              <el-divider></el-divider>
              <el-descriptions title="Anvil Integration" border direction="vertical">
                <template #extra>
                  <el-button type="primary" @click="openAnvilKeysDialog">Add Keys</el-button>
                </template>
                <el-descriptions-item label="Template ID" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.anvilTemplateId || '' }}
                </el-descriptions-item>
                <el-descriptions-item label="Version" :labelStyle="{ background: '#009aca', color: 'white' }">
                  {{ facilityData.anvilVersion || '' }}
                </el-descriptions-item>
              </el-descriptions>
              <el-divider></el-divider>
              <el-descriptions title="Braintree Integration" border direction="vertical">
                <template #extra>
                  <el-button type="primary" @click="() => braintreeDialog = true">Add Merchant Id</el-button>
                </template>
                <el-descriptions-item label="MID" :labelStyle="{ background: '#009aca', color: 'white' }">
                  <template v-if="facilityData.merchant && facilityData.merchant.merchantId">
                    {{ facilityData.merchant && facilityData.merchant.merchantId ? facilityData.merchant.merchantId : ''
                    }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </el-descriptions-item>
              </el-descriptions>
              <el-divider></el-divider>
              <el-descriptions v-if="facilityData" title="Crexi Integration" border direction="vertical">
                <template #extra>
                  <el-button size="small" type="danger" @click="() => openCrexiDialog()">Setup</el-button>
                </template>
                <el-descriptions-item
                  label="Crexi Type"
                  :labelStyle="{background: '#009aca', color: 'white' }"
                >
                    {{ facilityData && facilityData.crexi && facilityData.crexi.priceType ? facilityData.crexi.priceType : '' }}
                </el-descriptions-item>
                <el-descriptions-item
                  label="Crexi ID"
                  :labelStyle="{background: '#009aca', color: 'white' }"
                >
                    {{ facilityData && facilityData.crexi && facilityData.crexi.id ? facilityData.crexi.id : '' }}
                </el-descriptions-item>

                <el-descriptions-item
                  v-if="facilityData && facilityData.crexi && facilityData.crexi.migration && facilityData.crexi.migration.triggeredAt"
                  label="Migration Triggered At"
                  :labelStyle="{background: '#009aca', color: 'white' }"
                >
                  {{ facilityData.crexi.migration.triggeredAt | formatDate  }}
                </el-descriptions-item>
                <el-descriptions-item
                  v-if="facilityData && facilityData.crexi && facilityData.crexi.migration && facilityData.crexi.migration.triggeredBy"
                  label="Migration Triggered By"
                  :labelStyle="{background: '#009aca', color: 'white' }"
                >
                  {{ facilityData.crexi.migration.triggeredBy  }}
                </el-descriptions-item>

                <el-descriptions-item
                  v-if="facilityData && facilityData.crexi && facilityData.crexi.migration && facilityData.crexi.migration.workflow"
                  label="Migration Workflow"
                  :labelStyle="{background: '#009aca', color: 'white' }"
                >
                  <el-tag>
                    {{ facilityData.crexi.migration.workflow }}
                  </el-tag>
                </el-descriptions-item>
              </el-descriptions>
            </div>
            <el-dialog title="Crexi Migration"
              :visible.sync="crexiDialogVisible"
              destroy-on-close
            >
              <template v-if="crexiDialogVisible">
                <el-form :form="crexi">
                  <el-form-item
                    label="Crexi ID"
                    :rules="[
                      { required: true, message: 'Please input Crexi ID for facility', trigger: 'blur' },
                      { type: 'number', message: 'Please add Crexi ID for facility', trigger: ['blur', 'change'] }
                    ]"
                  >
                    <el-input-number
                     :disabled="facilityData.crexi && facilityData.crexi.migration && facilityData.crexi.migration.workflow" :controls="false" v-model="crexi.id"></el-input-number>
                  </el-form-item>
                  <el-form-item label="Crexi Type" prop="crexi.priceType"
                    :rules="[
                      { required: true, message: 'Please select Crexi type for facility', trigger: 'blur' },
                      { type: 'string', message: 'Please select Crexi type for facility', trigger: ['blur', 'change'] }
                    ]"
                  >
                    <el-select
                      v-model="crexi.priceType"
                      placeholder="Select Crexi type"
                      size="small"
                      style="width: 100%;"
                    >
                      <el-option label="FSG" value="FSG"></el-option>
                      <el-option label="NNN" value="NNN"></el-option>
                      <el-option label="No Price" value="No Price"></el-option>
                    </el-select>
                    <el-button type="danger" @click="migrateUnits" v-if="!facilityData.crexi || (facilityData && !facilityData.crexi && !facilityData.crexi.migration && !facilityData.crexi.migration.workflow)">
                      Migrate
                    </el-button>
                    <el-button type="warning" @click="migrateUnits" v-else>
                      Sync Suites
                    </el-button>
                  </el-form-item>
                </el-form>
              </template>
            </el-dialog>
            <el-dialog
              title="Edit Banner note"
              :visible.sync="bannerNoteDialogVisible"
              destroy-on-close
            >
              <template>
                <el-input style="margin-bottom: 2rem;" v-model="facilityData.bannerNote"></el-input>
                <el-button @click="() => facilityData.bannerNote = ''">Clear</el-button>
                <el-button :loading="dialogConfirmLoading" type="primary" @click="updateBannerNote">Save</el-button>
              </template>
            </el-dialog>
            <el-dialog title="Braintree Integration" :visible.sync="braintreeDialog" destroy-on-close>
              <template>
                <el-card shadow="never">
                  <el-form :model="braintreeForm" ref="braintree-form">
                    <el-form-item prop="merchantId" label="MID" required>
                      <el-input v-model="braintreeForm.merchantId"></el-input>
                    </el-form-item>
                    <el-button @click="addMerchantKeys">Save</el-button>
                  </el-form>
                </el-card>
              </template>
            </el-dialog>
            <el-dialog title="Anvil Keys" :visible.sync="anvilKeysDialog" destroy-on-close>
              <template>
                <el-form :model="form" ref="form">
                  <el-form-item prop="templateId" label="Template ID">
                    <el-input @blur="loadIcon" @clear="clearFields" v-model="form.templateId">
                      <i slot="suffix" :class="templateIcon"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="version" label="Version">
                    <el-input v-model="form.version"></el-input>
                  </el-form-item>
                  <el-button @click="addAnvilKeys">Save</el-button>
                </el-form>
              </template>
            </el-dialog>
            <div class="info-docs">
              <el-descriptions title="Documents" direction="vertical" border :column="1">
                <el-descriptions-item :key="doc.name" v-for="doc of facilityData.officialDocs" :label="doc.name">
                  <el-link v-if="doc.url" icon="el-icon-document" :href="doc.url">
                    {{ doc.name }}.pdf
                  </el-link>
                  <Upload
                    v-if="hasAccess"
                    pdf
                    @upload-completed="(url) => handleUpload(doc, url)"
                    :upload-prefix="`location/${facility}/`"
                  />
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane name="tax" label="Tax">
        <FacilityTaxSettings :facility="facility" :facilitySecurityFee="{ ...facilityData.securityFee }" />
      </el-tab-pane>
      <el-tab-pane name="penalty" label="Late Move-Out">
        <FacilityPenalty :facility="facility"></FacilityPenalty>
      </el-tab-pane>
      <el-tab-pane name="creditCardFee" label="Credit Card Fee">
        <FacilityCreditCardFee :facility="facility" />
      </el-tab-pane>
      <el-tab-pane name="achreturnfee" label="Ach Return Fee">
        <FacilityAchReturnFee :facility="facility" />
      </el-tab-pane>
      <el-tab-pane name="LateFee" label="Late Fee">
        <FacilityLateFee :facility="facility" />
      </el-tab-pane>
      <el-tab-pane name="SecurityFee" label="Security Fee">
        <FacilitySecurityFee :facility="facility" @reload-facility="getFacility" />
      </el-tab-pane>
      <el-tab-pane name="operations" label="Operations">
        <FacilityOpsInfoForm :facility="facility" />
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import axios from 'axios';
import FacilityTaxSettings from './FacilityTaxSettings.vue';
import FacilityCreditCardFee from './FacilityCreditCardFee.vue';
import FacilityAchReturnFee from './FacilityAchReturnFee.vue';
import FacilityLateFee from './FacilityLateFee.vue';
import FacilityPenalty from './FacilityPenalty.vue';
import FacilitySecurityFee from './FacilitySecurityFee.vue';
import FacilityOpsInfoForm from './FacilityOpsInfoForm.vue';
import Upload from './Uploader.vue';
import { ADMIN_API_BASE, RS_ANVIL_API, UNITS_API_BASE, isDevelopment } from '../env';
import facilityOfficialDocuments from '../utils/facilityOfficialDocuments';

export default {
  name: 'Facility',
  components: {
    FacilityTaxSettings,
    Upload,
    FacilityCreditCardFee,
    FacilityAchReturnFee,
    FacilityLateFee,
    FacilityPenalty,
    FacilitySecurityFee,
    FacilityOpsInfoForm,
  },
  props: {
    facility: { type: String, required: true },
  },
  data() {
    return {
      facilityData: null,
      crexi: {
        priceType: '',
        id: null,
      },
      sandboxFlag: false,
      bannerNoteDialogVisible: false,
      crexiDialogVisible: false,
      loading: true,
      dialogConfirmLoading: false,
      data: {},
      activeTab: 'info',
      anvilKeysDialog: false,
      braintreeDialog: false,
      braintreeForm: {
        merchantId: '',
      },
      form: {
        templateId: '',
        version: '',
      },
      icons: [
        'el-icon-close red',
        'el-icon-check green',
        'el-icon-loading',
      ],
      templateIcon: '',
      templateIdVerfying: false,
      showPassword: false,
    };
  },
  watch: {
    async facility() {
      this.loading = true;
      this.crexi = {
        priceType: '',
        id: null,
      };
      await this.getFacility();
      await this.getFacilityOccupancy();
      this.loading = false;
    },
  },
  computed: {
    isProd() {
      return !!isDevelopment;
    },
    hasAccess() {
      const roles = this.$keycloak.tokenParsed.realm_access.roles;
      if (roles.includes('level_1') || roles.includes('level_2') || roles.includes('level_3')) {
        return true;
      }
      return false;
    },
    country() {
      if (this.facilityData.addressInfo.country === 'us') {
        return 'United States of America';
      }
      return 'Canada';
    },
  },
  async mounted() {
    this.loading = true;
    await this.getFacility();
    await this.getFacilityOccupancy();
    this.loading = false;
  },
  methods: {
    openCrexiDialog() {
      this.crexiDialogVisible = true;
    },
    async migrateUnits() {
      this.loading = true;
      if (!this.crexi.id) {
        this.$message.error({
          message: 'ID cannot be empty',
        });
        this.loading = false;
        return;
      }

      if (!this.crexi.priceType) {
        this.$message.error({
          message: 'Price Type cannot be empty',
        });
        this.loading = false;
        return;
      }

      try {
        const response = await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}/crexi/migrate`, {
          id: this.crexi.id,
          priceType: this.crexi.priceType,
        }, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        });

        this.$message.success({
          message: `Workflow ID: ${response.data.workflowId} started`,
        });
      } catch (err) {
        console.log(err);
        this.$message.error({
          message: 'Something went wrong',
        });
      }
      await this.getFacility();
      this.loading = false;
    },
    async updateBannerNote() {
      this.dialogConfirmLoading = true;
      try {
        const result = await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`,
          { bannerNote: this.facilityData.bannerNote },
          { headers: { Authorization: `Bearer ${this.$keycloak.token}` } },
        );
        this.$root.$data.setFacilityDataAction(result.data);
        this.dialogConfirmLoading = false;

        this.$message.success({
          title: 'Success',
          message: 'Banner note updated successfully!',
        });
      } catch (error) {
        this.dialogConfirmLoading = false;

        this.$message.error({
          title: 'Error',
          message: 'There was an error updating the banner note',
        });
        this.getFacility();
      }
      this.bannerNoteDialogVisible = false;
    },
    routeToPreviousPage() {
      // this.$router.push({ name: 'Customers' });
      this.$router.go(-1);
    },
    routeToEditFacility() {
      this.$router.push({ name: 'Facility Edit', params: { facility: this.facility } });
    },
    openAnvilKeysDialog() {
      this.anvilKeysDialog = true;
    },
    async addMerchantKeys() {
      this.loading = true;
      if (!this.braintreeForm.merchantId) {
        this.loading = false;
        this.$message.error({
          title: 'Error',
          message: 'Please add the merchant id.',
        });
        return;
      }

      await axios.put(`${ADMIN_API_BASE}/facilities/merchant/${this.facility}`, {
        ...this.braintreeForm,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      await this.getFacility();
      this.braintreeDialog = false;
      this.loading = false;
    },
    async addAnvilKeys() {
      try {
        this.loading = true;
        const response = await axios.get(`${RS_ANVIL_API}/cast/${this.form.templateId}`,
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
        if (response.data !== 'OK' && response.data.cast.eid === this.form.templateId) {
          await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
            anvilTemplateId: this.form.templateId,
            anvilVersion: this.form.version,
          },
            {
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
              },
            });
          await this.getFacility();
          this.anvilKeysDialog = false;
        } else {
          this.loading = false;
          this.$message.error({
            title: 'Error',
            message: 'Invalid Template ID',
          });
        }
      } catch (err) {
        this.loading = false;
        this.$message.error({
          title: 'Error',
          message: err.response.data,
        });
      }
    },
    async handleUpload(doc, url) {
      this.loading = true;
      this.facilityData.officialDocs = this.facilityData.officialDocs.map((item) => {
        if (item.name === doc.name) {
          item.url = url;
          return item;
        }
        return item;
      });

      try {
        const updatedFacility = await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
          officialDocs: this.facilityData.officialDocs,
        },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });

        this.facilityData = updatedFacility.data;
        this.$message.success({
          title: 'Success',
          message: 'Facility document updated successfully!',
        });

        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$message.error({
          title: 'Error',
          message: err.response.data,
        });
        console.log(err);
      }
    },
    async getFacilityOccupancy() {
      const roles = this.$keycloak.tokenParsed.realm_access.roles;
      if ((this.$keycloak.tokenParsed.locations && this.$keycloak.tokenParsed.locations.includes(this.facility)) || roles.includes('level_1')) {
        try {
          const response = await axios.get(`${UNITS_API_BASE}/dashboard/occupancy/${this.facility}`, {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
          const data = response.data.result;
          this.data = data;
        } catch (err) {
          this.$message({
            showClose: true,
            offset: 60,
            type: 'error',
            duration: 10000,
            message: err.response.data,
          });
        }
      } else {
        this.$message.warning({
          type: 'warning',
          message: 'Manager not assigned to this facility',
        });
      }
    },
    async getFacility() {
      try {
        const facility = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.facilityData = facility.data;
        if (this.facilityData && this.facilityData.crexi) {
          this.crexi = this.facilityData.crexi;
        }

        this.sandboxFlag = facility.data.sandbox;
        if (!this.facilityData.officialDocs || this.facilityData.officialDocs.length === 0) {
          this.facilityData.officialDocs = facilityOfficialDocuments();
        } else {
          const names = this.facilityData.officialDocs.map(doc => doc.name);

          if (!names.includes('Floor Plan')) {
            this.facilityData.officialDocs.push({ name: 'Floor Plan', url: '' });
          }

          if (!names.includes('Flyer')) {
            this.facilityData.officialDocs.push({ name: 'Flyer', url: '' });
          }
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
        if (err.response && err.response.data) {
          this.$message.error({
            title: 'Error',
            message: err.response.data,
          });

          if (err.response.data === 'access_denied') {
            this.$router.push({ name: '404' });
          }
        }
      }
    },
    async setSandboxFlag(flag) {
      try {
        this.loading = true;
        await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
          sandbox: flag,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.facilityData.sandbox = flag;
        this.loading = false;
        this.$message.success({
          title: 'Success',
          message: flag ? 'Sandbox Enabled successfully' : 'Sandbox disabled successfully',
        });
      } catch (err) {
        this.loading = false;
        this.$message.error({
          title: 'Error',
          message: err.message ? err.message : err.resposne.data.toUpperCase(),
        });
      }
    },
    loadIcon() {
      this.$refs.form.validateField('templateId', async () => {
        this.templateIcon = this.icons[2];
        const response = await axios.get(`${RS_ANVIL_API}/cast/${this.form.templateId}`,
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
        if (response.data !== 'OK' && response.data.cast.eid === this.form.templateId) {
          this.templateIcon = this.icons[1];
        } else {
          this.templateIcon = this.icons[0];
          this.$message.error({
            title: 'Error',
            message: 'Invalid Template ID',
          });
        }
      });
    },
    clearFields() {
      this.templateIcon = '';
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async copyPassword() {
      if (!this.facilityData.wifiDetails.password) {
        this.$message.warning({
          message: 'No password to copy',
        });
        return;
      }

      try {
        await navigator.clipboard.writeText(this.facilityData.wifiDetails.password);
        this.$message.success({
          message: 'Password copied to clipboard',
        });
      } catch (err) {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = this.facilityData.wifiDetails.password;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.$message.success({
            message: 'Password copied to clipboard',
          });
        } catch (fallbackErr) {
          this.$message.error({
            message: 'Failed to copy password',
          });
        }
        document.body.removeChild(textArea);
      }
    },
  },
};
</script>

<style scoped>
.info-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.info-controls {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.el-button+.el-button {
  margin-left: 0;
}

@media (min-width: 768px) {
  .info-section {
    display: grid;
    grid: 2rem 1fr / repeat(6, 1fr);
    gap: 1rem;
  }

  .info-controls {
    flex-direction: row;
    align-items: center;
    justify-content: end;
    grid-row: 1 / 2;
    grid-column: 1 / 7;
  }

  .info-details {
    grid-row: 2 / 3;
    grid-column: 1 / 6;
  }

  .info-docs {
    grid-row: 2 / 3;
    grid-column: 6 / 7;
  }
}

.password-field {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.password-text {
  font-family: 'Courier New', monospace;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  min-width: 100px;
}

.password-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.password-actions .el-button {
  font-size: 11px;
  padding: 4px 8px;
  height: 24px;
  line-height: 1.1;
}

@media (max-width: 768px) {
  .password-field {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .password-actions {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Facility.vue